<template>
	<main ref="main" role="main" class="exhibitions">
		<ul class="exhibitionsList">
			<li v-for="subpage in subpages" :key="subpage.uid">
				<span :class="'itemContainer ' + [subpage.isOver ? 'is-active' : '']">
					<router-link
						@mouseenter.native="onEnter(subpage)"
						@mouseleave.native="onLeave(subpage)"
						:to="{ name: subpage.type, params: { uid: subpage.uid } }"
						>
						<h2 class="titleContainer">
							<span class="title">{{ subpage.title }}</span>
							<span :class="{ 'is-hidden': nodate(subpage) }">{{exhibitionDates(subpage)}}</span>
						</h2>
						<span class="artist" v-html="artists(subpage)"></span>
					</router-link>
				</span>
			</li>
		</ul>
		<div class="heroContainer">
			<img
				v-if="(Mutables.mediaType === 'image') & Mutables.isActive"
				:src="Mutables.mediaUrl"
				alt=""
			/>
			<video
				v-if="(Mutables.mediaType === 'video') & Mutables.isActive"
				ref="video"
				autoplay
				playsinline
				muted
				loop
			>
				<source :src="Mutables.mediaUrl.replace(Mutables.mediaExtension, '') + 'webm'" :type="'video/webm'" />
				<source :src="Mutables.mediaUrl.replace(Mutables.mediaExtension, '') + 'mp4'" :type="'video/mp4'" />
			</video>
		</div>
	</main>
</template>

<script>
export default {
	name: 'exhibitions',
	metaInfo() {
		return {
			title: this.title,
		};
	},
	computed: {
		subpages() {
			return this.$store.getters.getPagesByType('exhibition');
		},
	},
	props: {
		isActive: {
			type: Boolean,
			default: false,
		},
		mediaType: {
			type: String,
			default: () => '',
		},
		mediaUrl: {
			type: String,
			default: () => '',
		},
		mediaMime: {
			type: String,
			default: () => '',
		},
		isTablet: {
			type: Boolean,
			default: () => false,
		},
	},
	data() {
		return {
			Mutables: {
				IsActive: this.isActive,
				mediaType: this.mediaType,
				mediaExtension: this.mediaExtension,
				mediaUrl: this.mediaUrl,
				mediaMime: this.mediaMime,
				isTablet: this.isTablet,
			},
			title: this.$store.getters.getPageByUID('exhibitions').title,
		};
	},
	mounted() {
		this.$refs.main.focus();

		this.Mutables.isTablet = this.isTablet;
		this.$store.watch(
			() => this.$store.getters.getTablet,
			(value) => {
				if (value) {
					this.Mutables.isTablet = true;
				} else {
					this.Mutables.isTablet = false;
				}
			},
			{ immediate: true }
		);
	},
	methods: {
		exhibitionDates(subpage) {
			let page = subpage;
			let begining = new Date(page.begining);
			let end;
			let endString;
			if (page.end) end = new Date(page.end);

			// let beginingSting = begining.toLocaleString('en-gb', { month: 'short' }) + '. ' + begining.getDate()
			// let endString = end.toLocaleString('en-gb', { month: 'short' }) + '. ' + end.getDate()

			let beginingSting =
				('0' + begining.getDate()).slice(-2) +
				'.' +
				('0' + (begining.getMonth() + 1)).slice(-2);
			if (page.end)
				endString =
					('0' + end.getDate()).slice(-2) +
					'.' +
					('0' + (end.getMonth() + 1)).slice(-2);

			if (page.end)
				return begining.getFullYear() === end.getFullYear()
					? beginingSting + '–' + endString + ',' + end.getFullYear()
					: beginingSting +
							'.' +
							begining
								.getFullYear()
								.toString()
								.substr(-2) +
							'–' +
							endString +
							'.' +
							end
								.getFullYear()
								.toString()
								.substr(-2);

			return beginingSting + ',' + begining.getFullYear();
		},
		nodate(subpage) {
			let page = subpage;
			let nodate = page.isexception;
			if (!page.isexception) {
				return false;
			}
			let isnodate = false;
			if (nodate.includes('nodate')) isnodate = true;
			return isnodate;
		},
		onEnter(page) {
			page.isOver = true;
			let imghero = page.imghero;
			page.files.forEach((file) => {
				if (file.url.includes(imghero)) {
					imghero = file;
				}
			});

			this.Mutables.mediaType = imghero.type;
			this.Mutables.mediaUrl = imghero.url;
			this.Mutables.mediaMime = imghero.mime;
			this.Mutables.mediaExtension = imghero.extension;
			this.Mutables.isActive = true;
		},
		onLeave(page) {
			page.isOver = false;
			this.Mutables.isActive = false;
			this.Mutables.mediaType = '';
			this.Mutables.mediaUrl = '';
			this.Mutables.mediaExtension = '';
			this.Mutables.mediaMime = '';
		},
		artists(subpage) {
			let page = subpage;
			let artists = page.artist;

			artists = artists.split(',');

			let artistsString = '';
			artists.forEach((el, i) => {
				if (i < artists.length - 1) {
					// artistsString += el + '<br>'
					// artistsString += el + '&#8201;✳&#8201;'
					artistsString += el + ', ';
				} else {
					artistsString += el;
				}
			});

			// if (artists.length > 1) {
			// 	artistsString = 'Group show'
			// } else {
			// 	artistsString = artists[0]
			// }

			return artistsString;
		},
	},
};
</script>

<style lang="scss">
@import './../assets/styles/general/mixins';
@import './../assets/styles/config';

.exhibitions {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
		padding: 1.6em 1.6em;
		@include fluid-type(350px, 1400px, 5px, 12px);

	::-moz-selection {
		/* Code for Firefox */
		color: transparent; // text-shadow: 0px 0px 3px black, 0px 0px 9px black, 0px 0px 15px black;
		// text-shadow: 0px 0px 0.25rem black, 0px 0px 0.75rem black, 0px 0px 1.25rem black;
		text-shadow: 0px 0px 0.1em black;
	}

	::selection {
		color: transparent; // text-shadow: 0px 0px 3px black, 0px 0px 9px black, 0px 0px 15px black;
		// text-shadow: 0px 0px 0.25rem black, 0px 0px 0.75rem black, 0px 0px 1.25rem black;
		text-shadow: 0px 0px 0.1em black;
	}
	.exhibitionsList {
		width: 50%;
			@media screen and (max-width: $mq-tablet) {
				width: auto;
				// margin-bottom: 3em;
			}
	}
	li {
		display: flex;
		// padding-right: 2rem;
		max-width: 100%;
		@media screen and (max-width: $mq-tablet) {
			flex-wrap: wrap;
			// margin-bottom: 2em;
		}
		&:first-child {
			a {
				padding-top: 0;
			}
		}
		.itemContainer {
			display: flex;
			width: 100%;
			// line-height: 1.2;
			// margin-bottom: 1em;
			&.is-active {
				position: relative;
				// z-index: 10;
					color: #808080;
					color: #808080;
			}
			@media screen and (max-width: $mq-tablet) {
				// flex-wrap: wrap;
				display: inline;
				width: auto;
				max-width: 100%;
				// margin-bottom: 3em;
			}
		}

		a {
			font-size: 1em; //WALLSTREET
			// font-size: 1.5em; //WALLSTREET
			display: block;
			max-width: 100%;
			padding: 1em 0;
			// white-space: nowrap; //WALLSTREET
			// text-overflow: ellipsis; //WALLSTREET
			// width: 100%; //WALLSTREET
			// overflow-x: hidden; //WALLSTREET
			// overflow-y: hidden; //WALLSTREET
			// vertical-align: top; //WALLSTREET
			// padding: 0.75em 0;
		}
		.titleContainer {
			// text-transform: uppercase;
			font-size: 1.4rem; //WALLSTREET
			// @include fluid-type(400px, 1300px, 11.666666px, 12px); //WALLSTREET
			line-break: 1.2;
				@media screen and (max-width: 600px) {
			font-size: 1.2rem;
		}
			span {
				font-family: Arial;
				font-weight: bold;
			}
				width: 100%;
				// font-size: 3em; //WALLSTREET
				white-space: nowrap; //WALLSTREET
				text-overflow: ellipsis; //WALLSTREET
				max-width: 100%; //WALLSTREET
				overflow-x: hidden; //WALLSTREET
				vertical-align: top; //WALLSTREET
			@media screen and (max-width: $mq-tablet) {
			}
		}
		.title {
			&:after {
				content: ', ';
			}
		}
		.dates {
			font-variant-numeric: tabular-nums;
			font-size: 1.4rem;
			font-family: Arial;
			font-weight: bold;
			// padding-right: 1em;
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
			line-height: 1.2;
					@media screen and (max-width: 600px) {
			font-size: 1.2rem;
		}
			&.is-hidden {
				visibility: hidden;
			}
		}
		.artist {
			// display: none;
			width: 100%;
			// display: block;
			font-size: 5em;
			line-height: 1;
			// white-space: nowrap;
			// text-overflow: ellipsis;
			display: block;
			overflow: hidden;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			box-orient: vertical;
			-webkit-line-clamp: 2;
			line-clamp: 2;
			padding-top: 0.2em;
			position: relative;
			&:after {
				display: block;
				content: '';
				width: 100%;
				background: white;
				bottom: 0;
				left: 0;
				position: absolute;
				height: 0.15em;
			}
		@media screen and (max-width: 1450px) {
			font-size: 4.5em;
		}
			@media screen and (max-width: $mq-tablet) {
				// white-space: normal;
				// overflow: auto;
				// overflow: visible;
				// text-overflow: clip;
				font-size: 5em;
				// padding-right: 0;
				// order: 2;
				br {
					display: inline-block;
					&:before {
						color: black;
						content: ', ';
					}
				}
			}
		}

	}
	.heroContainer {
		pointer-events: none;
		width: 50vw;
		height: 100vh;
		height: var(--vh);
		object-fit: contain;
		margin: auto;
		overflow: hidden;
		position: fixed;
		top: 0;
		right: 0;
		// transform: translate(-50%, -50%);
		z-index: -5;
		@media screen and (max-width: $mq-tablet) {
			display: none;
		}
	}
	img,
	video {
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: 50% 50%;
	}
}
</style>
